import { Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { BaseHttpClient } from '../../services/http-client';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ConfigService } from '../../services/config.service';

@Injectable()
export class HomeService {
    public dashboardData = signal<any>(null);
    constructor(private router: Router, private http: BaseHttpClient, private configService: ConfigService) { }

    getWebPage(menuId, childMenuId, subChildMenuId, webPageId) {
        return this.http.get(`${this.configService.get('apiBaseUrl')}/WebPage/GetWebPage?menuId=${menuId}&childMenuId=${childMenuId}&subChildMenuId=${subChildMenuId}&webPageId=${webPageId}`)
            .pipe(map((response: any) => {
                return response;
            }));
    }

    getTimeStats(fromDate, toDate) {
        return this.http.get(`${this.configService.get('apiBaseUrl')}/Summary/GetTimeStats?fromDate=${fromDate}&todate=${toDate}`).pipe(map((response: any) => {
            return response;
        }));
    }

    getNewsById(id) {
        return this.http.get(`${this.configService.get('apiBaseUrl')}/News/GetNewsById?id=${id}`).pipe(map((response: any) => {
            return response;
        }));
    }

    getFrontNews(showAll) {
        return this.http.get(`${this.configService.get('apiBaseUrl')}/News/GetFrontNews?showAll=${showAll}`).pipe(map((response: any) => {
            return response;
        }));
    }

    getNewsComments(newsId: number) {
        return this.http.get(`${this.configService.get('apiBaseUrl')}/News/GetNewsComments?newsId=${newsId}`).pipe(map((response: any) => {
            return response;
        }));
    }

    addNewsComment(newsId: number, commentText: string) {
        return this.http.post(`${this.configService.get('apiBaseUrl')}/News/AddNewsComment`, { newsID: newsId, commentText }).pipe(map((response: any) => {
            return response;
        }));
    }

    deleteNewsComment(commentId: number) {
        return this.http.post(`${this.configService.get('apiBaseUrl')}/News/DeleteNewsComment`, { commentID: commentId }).pipe(map((response: any) => {
            return response;
        }));
    }

    getNewsReactions(newsId: number) {
        return this.http.get(`${this.configService.get('apiBaseUrl')}/News/GetNewsReactions?newsId=${newsId}`).pipe(map((response: any) => {
            return response;
        }));
    }

    setNewsReaction(newsId: number, reaction: string | null) {
        return this.http.post(`${this.configService.get('apiBaseUrl')}/News/SetNewsReaction`, { newsID: newsId, reaction }).pipe(map((response: any) => {
            return response;
        }));
    }
}